import View from '@/components/common/view'
import Index from '../components/customizedEmployerLiability/Index';
import EmployerFillin from '../components/customizedEmployerLiability/Fillin';
import EmployerFillinCompany from '../components/customizedEmployerLiability/FillinCompany';

import EmployerConfirm from '../components/customizedEmployerLiability/Confirm';
import EmployerConfirmCompany from '../components/customizedEmployerLiability/ConfirmCompany';


import calssType from '../components/customizedEmployerLiability/calssType';
import bidDetail from '../components/customizedEmployerLiability/productList/bidDetail';
import renovationDetail from '../components/customizedEmployerLiability/productList/renovationDetail';
import allRisks from '../components/customizedEmployerLiability/productList/allRisks';
import farmer from '../components/customizedEmployerLiability/productList/farmer';
import guarantee from '../components/customizedEmployerLiability/productList/guarantee';
import proceeding from '../components/customizedEmployerLiability/productList/proceeding';
import safeProduction from '../components/customizedEmployerLiability/productList/safeProduction';



export default [
    {
        path: '',
        component: View,
        children: [
            {
                path: '',
                component: Index
            },
            {
                path: 'fillin/:id?',
                component: EmployerFillin
            },
            {
                path: 'FillinCompany/:id?',
                component: EmployerFillinCompany
            },
            {
                path: 'confirm/:id?',
                component: EmployerConfirm
            },
            {
                path: 'ConfirmCompany/:id?',
                component: EmployerConfirmCompany
            },
            {
                path: 'calssType',
                component: calssType
            },
            {
                path: 'bidDetail',
                component: bidDetail
            },
            {
                path: 'renovationDetail',
                component: renovationDetail
            },
            {
                path:'allRisks',
                component:allRisks
            },
            {
                path:'farmer',
                component:farmer
            },
            {
                path:'guarantee',
                component:guarantee
            },
            {
                path:'proceeding',
                component:proceeding
            },
            {
                path:'safeProduction',
                component:safeProduction
            }
        ]
    }
]



// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/customizedEmployerLiability.js